import {
    Table,
    TableBody,
    TableRow,
    TableCell,
    Typography,
    Box,
} from '@mui/material';
import formatCurrency from 'utils/formatCurrency';
import useAuth from 'hooks/useAuth';

const SummaryTable = ({ cart }) => {
    const {
        package: plan,
        sympoPrice,
        totalPrice,
        workshops,
        bundleDiscount,
    } = cart;
    const { user } = useAuth();
    const isNurse = user?.profession?.name === 'Nurse';
    const hasWorkshopDiscountSelected =
        (workshops || []).some((ws) => ws?.isDiscount) || false;

    const { wsFullDayIncludes, wsHalfDayIncludes } = plan;
    const totalWorkshopPrice = workshops.reduce(
        (acc, ws) => acc + parseInt(ws.price || 0),
        0,
    );
    const selectedFullDayWorkshops = workshops.filter(
        (ws) => ws.workshopType.value == 'full_day',
    );
    const selectedHalfDayWorkshops = workshops.filter(
        (ws) => ws.workshopType.value == 'half_day',
    );

    return (
        <Table size="small" sx={{ width: '100%' }}>
            <TableBody>
                <TableRow>
                    <TableCell sx={{ width: 260 }}>
                        <Typography variant="body2" fontWeight={700}>
                            Include Workshop Half Day ({wsHalfDayIncludes})
                        </Typography>
                    </TableCell>
                    <TableCell>
                        {selectedHalfDayWorkshops.length > 0 ? (
                            selectedHalfDayWorkshops.map((ws, idx) => (
                                <Box
                                    key={ws?.id ?? idx}
                                    sx={{ display: 'block' }}
                                >
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                    >
                                        {idx + 1}. {ws?.name}
                                    </Typography>
                                </Box>
                            ))
                        ) : (
                            <Typography variant="body2" color="text.secondary">
                                -
                            </Typography>
                        )}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell sx={{ width: 260 }}>
                        <Typography variant="body2" fontWeight={700}>
                            Include Workshop Full Day ({wsFullDayIncludes})
                        </Typography>
                    </TableCell>
                    <TableCell>
                        {selectedFullDayWorkshops.length > 0 ? (
                            selectedFullDayWorkshops.map((ws, idx) => (
                                <Box
                                    key={ws?.id ?? idx}
                                    sx={{ display: 'block' }}
                                >
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                    >
                                        {idx + 1}. {ws?.name}
                                    </Typography>
                                </Box>
                            ))
                        ) : (
                            <Typography variant="body2" color="text.secondary">
                                -
                            </Typography>
                        )}
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell sx={{ width: 260 }}>
                        <Typography variant="body2" fontWeight={700}>
                            Symposium Price
                        </Typography>
                    </TableCell>
                    <TableCell>
                        <Typography variant="body2" color="text.secondary">
                            {formatCurrency(sympoPrice)}
                        </Typography>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell sx={{ width: 260 }}>
                        <Typography variant="body2" fontWeight={700}>
                            Total Workshop Price
                        </Typography>
                    </TableCell>
                    <TableCell>
                        <Typography variant="body2" color="text.secondary">
                            {formatCurrency(totalWorkshopPrice)}
                        </Typography>
                    </TableCell>
                </TableRow>
                {user?.hasDiscount &&
                    !(plan?.isBundle && hasWorkshopDiscountSelected && isNurse) && (
                    <TableRow>
                        <TableCell sx={{ width: 260 }}>
                            <Typography variant="body2" fontWeight={700}>
                                Symposium Discount
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Typography variant="body2" color={'success.main'}>
                                {formatCurrency(Math.floor(sympoPrice * 0.3))}
                            </Typography>
                        </TableCell>
                    </TableRow>
                )}
                <TableRow>
                    <TableCell sx={{ width: 260 }}>
                        <Typography variant="body2" fontWeight={700}>
                            Discount Package
                        </Typography>
                    </TableCell>
                    <TableCell>
                        <Typography variant="body2" color={'success.main'}>
                            {formatCurrency(bundleDiscount)}
                        </Typography>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell sx={{ width: 260 }}>
                        <Typography variant="body2" fontWeight={700}>
                            Total Price
                        </Typography>
                    </TableCell>
                    <TableCell>
                        <Typography variant="h6" fontWeight={800}>
                            {formatCurrency(totalPrice)}
                        </Typography>
                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );
};

export default SummaryTable;
